<template>
  <div class="box" :style="minHeight">
    <div class="message">
      <h3>{{message.title}}</h3>
      <p>{{message.content}}</p>
    </div>
  </div>
</template>

<script>
  import dataServer from '@/api/data'
  const getQuery = (variable) => {
    let query = window.location.search.substring(1);
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1]
      }
    }
    return false;
  }
  const id = getQuery('id')
  export default {
    name: "register",
    data(){
      return{
        minHeight: 'min-height: 480px',
        message: {}
      }
    },
    mounted() {
      this.minHeight = 'min-height: ' + document.documentElement.clientHeight + 'px'
      this.init()
    },
    methods:{
      /*获取验证码*/
      init(){
        /* dataServer.messageDetail({broadcastId: id}).then(res => {
          if(res.status==='SUCCEED'){
            this.message = res.data
          }
        }) */
      }
    }
  }
</script>

<style scoped lang="less">
  input {
    background: none;
    border: none;
    -webkit-appearance:none;
  }
  .box{
    background-color: #f7f7f7;
    padding: 0.15rem;
  }
  .message{
    background-color: #ffffff;
    padding: 0.2rem 0.15rem;
    h3{
      font-size: 0.15rem;
      margin: 0;
      padding-bottom: 0.15rem;
    }
    p{
      margin: 0;
      color: #999999;
    }
  }
</style>
